import React from 'react'
import { Typography, Layout, Divider, Button } from 'antd'
import { AppCard } from '@/shared/components/ui'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Title, Paragraph, Text } = Typography
const { Content } = Layout

const TermsPage: React.FC = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ padding: '24px' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {/* 返回按钮 */}
          <div style={{ marginBottom: '24px' }}>
            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={handleGoBack}
              style={{ marginBottom: '16px' }}
            >
              返回
            </Button>
          </div>

          <AppCard
            borderless
            style={{
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
            }}
          >
            {/* 标题 */}
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <Title level={2} style={{ color: '#1890ff' }}>
                多智能体客服系统服务条款
              </Title>
              <Text type="secondary">最后更新日期：2025年12月7日</Text>
            </div>

            <Divider />

            {/* 内容区域 */}
            <div style={{ lineHeight: '1.8' }}>
              <Paragraph>
                欢迎使用多智能体客服系统（以下简称"本系统"）。在注册和使用本系统前，请仔细阅读以下服务条款。
              </Paragraph>

              <Title level={3}>1. 服务概述</Title>
              <Paragraph>
                本系统是一个基于人工智能的多智能体客服平台，为企业提供智能客服解决方案。本系统提供包括但不限于：智能对话、知识库管理、客服历史记录、数据分析等功能。
              </Paragraph>

              <Title level={3}>2. 用户注册与账户</Title>
              <Paragraph>
                2.1 用户注册时需要提供真实、准确、完整的个人信息。
              </Paragraph>
              <Paragraph>
                2.2 用户有责任妥善保管账户密码，并对账户下的所有行为负责。
              </Paragraph>
              <Paragraph>
                2.3 如发现任何未经授权的账户使用行为，用户应立即通知我们。
              </Paragraph>

              <Title level={3}>3. 使用规范</Title>
              <Paragraph>
                3.1 用户不得利用本系统从事任何非法活动或违反公序良俗的行为。
              </Paragraph>
              <Paragraph>
                3.2 用户不得干扰或破坏本系统的正常运行。
              </Paragraph>
              <Paragraph>
                3.3 用户不得上传或传播任何含有病毒、木马等恶意程序的内容。
              </Paragraph>

              <Title level={3}>4. 知识产权</Title>
              <Paragraph>
                4.1 本系统的所有内容，包括但不限于软件、代码、界面设计、商标等，均受知识产权法保护。
              </Paragraph>
              <Paragraph>
                4.2 用户在本系统上传的内容，其知识产权仍归用户所有，但用户授予我们必要的使用许可。
              </Paragraph>

              <Title level={3}>5. 免责声明</Title>
              <Paragraph>
                5.1 本系统按照"现状"提供，不提供任何形式的明示或默示保证。
              </Paragraph>
              <Paragraph>
                5.2 对于因使用或无法使用本系统造成的任何损失，我们不承担责任。
              </Paragraph>
              <Paragraph>
                5.3 我们保留随时修改、暂停或终止服务的权利。
              </Paragraph>

              <Title level={3}>6. 隐私保护</Title>
              <Paragraph>
                我们重视用户的隐私保护，具体政策请参阅《隐私政策》。
              </Paragraph>

              <Title level={3}>7. 条款修改</Title>
              <Paragraph>
                我们有权根据需要修改本服务条款，修改后的条款将在系统中公布后生效。
              </Paragraph>

              <Title level={3}>8. 法律适用</Title>
              <Paragraph>
                本服务条款受中华人民共和国法律管辖并按其解释。
              </Paragraph>

              <Divider />

              {/* 联系信息 */}
              <div style={{ textAlign: 'center', marginTop: '32px' }}>
                <Title level={4}>联系我们</Title>
                <Paragraph type="secondary">
                  如有任何疑问，请联系我们：
                  <br />
                  邮箱：support@custom-service.com
                  <br />
                  电话：400-xxx-xxxx
                  <br />
                  地址：XX省XX市XX区XX街道XX号
                </Paragraph>
              </div>
            </div>
          </AppCard>

          {/* 底部信息 */}
          <div style={{ marginTop: '24px', textAlign: 'center' }}>
            <Text type="secondary">
              © 2025 多智能体客服系统 · 版本 1.0.0
            </Text>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default TermsPage